define('drops/treeView/multiSelection',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var MultiSelection = function (drop) {
        this.idsOfSelectedNodes = [];

        this.drop = drop;
    };

    MultiSelection.prototype.onCreateLi = function (node, $element) {
        var checkbox = $('<input type="checkbox" />')
            .on('change', this.onCheckboxToggled.bind(this, node, $element));

        if (!node.children.length)
            checkbox.addClass('leaf-node');

        $element
            .find('.jqtree-title')
            .before(checkbox);
    };

    MultiSelection.prototype.onCheckboxToggled = function(node, $element, e) {
        if ($(e.srcElement).prop('checked')) {
            this.drop.$tree.tree('addToSelection', node);

            this.idsOfSelectedNodes.push(node.id);

            this.drop.showAsSelected(node);
            this.drop.triggerEventIfEnabled('selected', node.id);
        } else {
            this.drop.$tree.tree('removeFromSelection', node);

            this.idsOfSelectedNodes = _.reject(this.idsOfSelectedNodes, function (idOfSelectedNode) {
                return idOfSelectedNode === node.id;
            });

            this.drop.showAsDeselected(node);
            this.drop.triggerEventIfEnabled('deselected', node.id);
        }

        this.drop.updateRequiredIndicator();
    };

    MultiSelection.prototype.getSelection = function () {
        return this.idsOfSelectedNodes;
    };

    MultiSelection.prototype.replaceWith = function (idsOfNodes) {
        this.deselectAll();

        this.idsOfSelectedNodes = $.isArray(idsOfNodes) ? idsOfNodes : [idsOfNodes];

        this.reselect();
    };

    MultiSelection.prototype.reset = function () {
        this.deselectAll();
        this.idsOfSelectedNodes = [];
    };

    MultiSelection.prototype.deselectAll = function () {
        var self = this;
        _.each(this.idsOfSelectedNodes, function (idOfSelectedNode) {
            var node = self.drop.$tree.tree('getNodeById', idOfSelectedNode);

            $(node.element).find('> .jqtree-element input[type=checkbox]').prop('checked', false);

            self.drop.$tree.tree('removeFromSelection', node);
            self.drop.showAsDeselected(node);
        });
    };

    MultiSelection.prototype.reselect = function() {
        var self = this;
        var nodes = _.chain(this.idsOfSelectedNodes)
            .map(function(idOfNode) {
                return self.drop.$tree.tree('getNodeById', idOfNode);
            })
            .filter(function(node) {
                return !!node
            })
            .value();

        _.each(nodes, function (node) {
            $(node.element).find('> .jqtree-element input[type=checkbox]').prop('checked', true);

            self.drop.$tree.tree('addToSelection', node);
            self.drop.showAsSelected(node);
        });

        this.idsOfSelectedNodes = _.pluck(nodes, 'id');
    };

    return MultiSelection;
});
